import SimpleFillSymbol from "@arcgis/core/symbols/SimpleFillSymbol";
import { PictureFillSymbol } from "@arcgis/core/symbols";
import { TGeometry } from "src/common/types/common";

export const DEFAULT_CENTER = [-84.2514244, 39.3858027]; // FECON headquarters, lat, lng
export const DEFAULT_FILL_SYMBOL = {
    type: "simple-fill",
    color: [232, 62, 140, 0.1],
    outline: {
        color: "#C10230",
        width: 2,
    },
} as unknown as SimpleFillSymbol;

export const MOCK_POLYGON: TGeometry = {
    rings: [
        [
            [DEFAULT_CENTER[0], DEFAULT_CENTER[1] + .003],
            [DEFAULT_CENTER[0] + .002, DEFAULT_CENTER[1] + .002],
            [DEFAULT_CENTER[0] + .003, DEFAULT_CENTER[1]],
            [DEFAULT_CENTER[0] + .002, DEFAULT_CENTER[1] - .002],
            [DEFAULT_CENTER[0], DEFAULT_CENTER[1] - .003],
            [DEFAULT_CENTER[0] - .002, DEFAULT_CENTER[1] - .002],
            [DEFAULT_CENTER[0] - .003, DEFAULT_CENTER[1]],
            [DEFAULT_CENTER[0] - .002, DEFAULT_CENTER[1] + .002],
            [DEFAULT_CENTER[0], DEFAULT_CENTER[1] + .003],
        ]
    ],
    spatialReference: {
        wkid: 4326
    }
};

export const TRACTOR_MARKET_SYMBOL = {
    type: "picture-marker", // autocasts as new PictureMarkerSymbol()
    url: "tractor.svg",
    width: "35px",
    height: "35px",
    yoffset: "10",
} as unknown as PictureFillSymbol;
